import { Link } from "react-router-dom";
import TopNav from "@/components/TopNav";

export default function LegalPageLayout({ label, title, updated, children }) {
  return (
    <div className="min-h-screen bg-white text-[#172033]">
      <TopNav />
      <main className="max-w-[900px] mx-auto px-5 sm:px-6 py-12 sm:py-16">
        <div className="fx-mono-tag mb-4">{label}</div>
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight">{title}</h1>
        <p className="mt-3 text-sm text-[#64748B]">Effective date: {updated}</p>

        <article className="mt-10 space-y-8 text-sm sm:text-base text-[#475569] leading-7">
          {children}
        </article>
      </main>

      <footer className="border-t border-[#DCE3ED] bg-white">
        <div className="max-w-[900px] mx-auto px-5 sm:px-6 py-7 flex flex-wrap gap-x-6 gap-y-2 text-xs">
          <Link to="/" className="text-[#0B4DCC] hover:underline">Home</Link>
          <Link to="/privacy" className="text-[#0B4DCC] hover:underline">Privacy Policy</Link>
          <Link to="/terms" className="text-[#0B4DCC] hover:underline">Terms of Use</Link>
          <a href="mailto:agenaix.ai@gmail.com" className="text-[#0B4DCC] hover:underline">
            agenaix.ai@gmail.com
          </a>
        </div>
      </footer>
    </div>
  );
}

export function Section({ title, children }) {
  return (
    <section>
      <h2 className="text-xl font-semibold tracking-tight text-[#172033] mb-3">{title}</h2>
      <div className="space-y-3">{children}</div>
    </section>
  );
}
